// DeskOne 新首页交互 — 由 assets/dko.js 全站加载，各模块自带空值守卫
  // v1.22: Build Your Workspace — 场景切换 + 热点联动 + ajax 加购（复用 Impulse 抽屉）
  (function(){
    var root = document.getElementById('dko-builder'); if(!root) return;
    var scenes = [].slice.call(root.querySelectorAll('.dko-scene'));
    if(!scenes.length) return;
    var tabs = [].slice.call(root.querySelectorAll('.dko-scene-tab'));
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    function money(cents){
      if(isNaN(cents)) return '';
      if(window.theme && theme.Currency && theme.Currency.formatMoney){
        try { return theme.Currency.formatMoney(cents, fmt); } catch(e){}
      }
      return '$' + (cents/100).toFixed(2);
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){
        scenes.forEach(function(s, x){ s.classList.toggle('dko-on', x === i); });
        tabs.forEach(function(b, x){ b.classList.toggle('dko-on', x === i); b.setAttribute('aria-selected', x === i ? 'true' : 'false'); });
      });
    });
    // 内层容器精确贴合"按比例缩放后"的图片尺寸：热点百分比才不失真，且底图零裁切
    // CSS 的 aspect-ratio 在被 max-width/max-height 夹断时不会回推另一边，所以这里用 JS 算
    var inners = [].slice.call(root.querySelectorAll('.dko-stage-inner'));
    function fitInner(inner){
      var im = inner.querySelector('img'), stage = inner.parentNode;
      if(!im || !im.naturalWidth || !im.naturalHeight) return;
      var sw = stage.clientWidth, sh = stage.clientHeight;
      // 窄屏是单列自然流，交回 CSS 处理
      if(!sh || window.innerWidth <= 1000){ inner.style.width = ''; inner.style.height = ''; return; }
      var r = im.naturalWidth / im.naturalHeight, w = sw, h = sw / r;
      if(h > sh){ h = sh; w = sh * r; }
      inner.style.width = Math.round(w) + 'px';
      inner.style.height = Math.round(h) + 'px';
    }
    function fitAll(){ inners.forEach(fitInner); }
    inners.forEach(function(inner){
      var im = inner.querySelector('img'); if(!im) return;
      if(im.complete) fitInner(inner); else im.addEventListener('load', function(){ fitInner(inner); });
    });
    var fitT; window.addEventListener('resize', function(){ clearTimeout(fitT); fitT = setTimeout(fitAll, 150); });
    scenes.forEach(function(sc){
      var dots = [].slice.call(sc.querySelectorAll('.dko-hs-dot'));
      var items = [].slice.call(sc.querySelectorAll('.dko-sl-item'));
      var box = sc.querySelector('.dko-sl-items');
      var subEl = sc.querySelector('[data-sub-cents]');
      function focusItem(i){
        dots.forEach(function(d, x){ d.classList.toggle('dko-on', x === i); });
        items.forEach(function(it, x){ it.classList.toggle('dko-on', x === i); });
        var el = items[i];
        // 只在清单自身可滚动时滚动它，避免把整页拽走
        if(el && box && box.scrollHeight > box.clientHeight + 4){ box.scrollTop = el.offsetTop - box.offsetTop - 8; }
      }
      dots.forEach(function(d, x){ d.addEventListener('click', function(){ focusItem(x); }); });
      items.forEach(function(it, x){ it.addEventListener('mouseenter', function(){ focusItem(x); }); });
      focusItem(0);
      function recalc(){
        var total = 0;
        items.forEach(function(it){ var c = parseInt(it.getAttribute('data-cents'), 10); if(!isNaN(c)) total += c; });
        if(subEl) subEl.textContent = money(total);
      }
      items.forEach(function(it){
        var sel = it.querySelector('.dko-sl-var'); if(!sel) return;
        sel.addEventListener('change', function(){
          var o = sel.options[sel.selectedIndex]; if(!o) return;
          it.setAttribute('data-cents', o.getAttribute('data-price'));
          var btn = it.querySelector('.dko-sl-add'); if(btn) btn.setAttribute('data-id', o.value);
          var pe = it.querySelector('.dko-sl-price'); if(pe) pe.textContent = money(parseInt(o.getAttribute('data-price'), 10));
          recalc();
        });
      });
      function addItems(list, btn){
        if(!list.length) return;
        var old = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        fetch('/cart/add.js', { method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: list }) })
          .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
          .then(function(res){
            btn.disabled = false;
            if(!res.ok){
              btn.textContent = (res.j && res.j.description) ? 'Unavailable' : 'Try again';
              setTimeout(function(){ btn.textContent = old; }, 2400);
              return;
            }
            btn.textContent = 'Added ✓';
            setTimeout(function(){ btn.textContent = old; }, 1800);
            // Impulse 原生事件：CartDrawer 收到后自动 buildCart() + open()
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(function(){
            btn.disabled = false; btn.textContent = 'Try again';
            setTimeout(function(){ btn.textContent = old; }, 2400);
          });
      }
      [].slice.call(sc.querySelectorAll('.dko-sl-add')).forEach(function(b){
        b.addEventListener('click', function(){
          var id = b.getAttribute('data-id'); if(!id) return;
          addItems([{ id: Number(id), quantity: 1 }], b);
        });
      });
      var all = sc.querySelector('.dko-sl-addall');
      if(all){
        all.addEventListener('click', function(){
          var list = [];
          [].slice.call(sc.querySelectorAll('.dko-sl-add')).forEach(function(b){
            var id = b.getAttribute('data-id'); if(id) list.push({ id: Number(id), quantity: 1 });
          });
          addItems(list, all);
        });
      }
    });
  })();
  // promo banner: collapse toggle + copy code
  (function(){
    var pb=document.getElementById('dko-promo'); if(!pb) return;
    var head=pb.querySelector('.dko-pb-head'), timer, auto=true;
    function setOpen(o){
      pb.classList.toggle('dko-open', o);
      head.setAttribute('aria-expanded', o);
      clearTimeout(timer);
      var acMs=(parseInt(pb.dataset.autoclose,10)||0)*1000;
      if(o && auto && acMs>0){ timer=setTimeout(function(){ setOpen(false); }, acMs); }
    }
    head.addEventListener('click', function(){ setOpen(!pb.classList.contains('dko-open')); });
    var codeBtn=pb.querySelector('.dko-pb-code');
    if(codeBtn){
      codeBtn.addEventListener('click', function(){
        var code=codeBtn.getAttribute('data-code')||'';
        var b=codeBtn.querySelector('b');
        function done(){ codeBtn.classList.add('dko-copied'); var old=b.textContent; b.textContent='Copied ✓'; setTimeout(function(){ codeBtn.classList.remove('dko-copied'); b.textContent=old; }, 1600); }
        function fallback(){ var ta=document.createElement('textarea'); ta.value=code; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.select(); try{ document.execCommand('copy'); }catch(e){} document.body.removeChild(ta); done(); }
        if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done, fallback); }else{ fallback(); }
      });
    }
    pb.addEventListener('mouseenter', function(){ if(pb.classList.contains('dko-open')) clearTimeout(timer); });
    pb.addEventListener('mouseleave', function(){ var ac=(parseInt(pb.dataset.autoclose,10)||0)*1000; if(ac>0 && pb.classList.contains('dko-open')){ clearTimeout(timer); timer=setTimeout(function(){ setOpen(false); }, Math.max(ac-2000,2000)); } });
    setOpen(true);
  })();
  // hero: auto-rotating carousel
  (function(){
    var wrap = document.getElementById('dko-heroCarousel'); if(!wrap) return;
    var slides = [].slice.call(wrap.querySelectorAll('.dko-hero-slide'));
    var dots = [].slice.call(wrap.querySelectorAll('.dko-hero-dots button'));
    var counter = wrap.querySelector('.dko-hero-count');
    var i = 0, n = slides.length, timer;
    function pad(v){ return v < 10 ? '0'+v : ''+v; }
    function goTo(k){
      i = (k % n + n) % n;
      slides.forEach(function(s,x){ s.classList.toggle('dko-active', x===i); });
      dots.forEach(function(d,x){ d.classList.toggle('dko-active', x===i); });
      if(counter) counter.textContent = pad(i+1) + ' / ' + pad(n);
    }
    function next(){ goTo(i+1); }
    var ivMs=(parseInt(wrap.dataset.interval,10)||5)*1000;
    function restart(){ clearInterval(timer); timer = setInterval(next, ivMs); }
    dots.forEach(function(d,x){ d.addEventListener('click', function(){ goTo(x); restart(); }); });
    wrap.addEventListener('mouseenter', function(){ clearInterval(timer); });
    wrap.addEventListener('mouseleave', restart);
    // 手机没有 hover：按下暂停、抬手恢复；横向滑动切图（纵向滑动不拦截，避免影响页面滚动）
    var tX = 0, tY = 0, swiping = false;
    wrap.addEventListener('touchstart', function(e){
      clearInterval(timer);
      var t0 = e.touches[0]; tX = t0.clientX; tY = t0.clientY; swiping = true;
    }, {passive:true});
    wrap.addEventListener('touchend', function(e){
      if(swiping){
        var t1 = e.changedTouches[0], dX = t1.clientX - tX, dY = t1.clientY - tY;
        if(Math.abs(dX) > 40 && Math.abs(dX) > Math.abs(dY)) goTo(dX < 0 ? i + 1 : i - 1);
        swiping = false;
      }
      restart();
    }, {passive:true});
    wrap.addEventListener('touchcancel', function(){ swiping = false; restart(); }, {passive:true});
    restart();
  })();
  // reviews: prev/next scroll
  (function(){
    var t = document.getElementById('dko-reviewTrack'); if(!t) return;
    // 步长按实际卡宽+间距实时算：桌面卡宽 320、≤1000px 变 270，写死 336 会在窄屏每次多滚 50px
    function step(){
      var card = t.querySelector('.dko-review-card');
      if(!card) return t.clientWidth;
      var cs = getComputedStyle(t), gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }
    var p = document.querySelector('.dko-rv-prev'), n = document.querySelector('.dko-rv-next');
    if(p) p.addEventListener('click', function(){ t.scrollBy({left:-step(), behavior:'smooth'}); });
    if(n) n.addEventListener('click', function(){ t.scrollBy({left:step(), behavior:'smooth'}); });
  })();

  // nav 下拉：飞出层超出视口右边界时翻转为右对齐，避免撑出整页横向滚动
  (function(){
    var items = [].slice.call(document.querySelectorAll('.dko-nav-item'));
    if(!items.length) return;
    function flip(){
      items.forEach(function(it){
        var dd = it.querySelector('.dko-dropdown, .dko-mega-menu');
        if(!dd) return;
        dd.classList.remove('dko-flip');
        if(dd.getBoundingClientRect().right > window.innerWidth - 8) dd.classList.add('dko-flip');
      });
    }
    flip();
    var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(flip, 150); });
  })();

  // 移动端目录抽屉：汉堡在左，抽屉也从左侧滑出（Impulse 的 drawer-menu snippet 写死了 drawer--right）
  (function(){
    var nd = document.getElementById('NavDrawer'); if(!nd) return;
    nd.classList.remove('drawer--right');
    nd.classList.add('drawer--left');
  })();

  // localization: 原生 select 改变即提交（货币/国家、语言）
  (function(){
    var sels = document.querySelectorAll('[data-dko-loc]');
    if(!sels.length) return;
    [].forEach.call(sels, function(s){
      s.addEventListener('change', function(){ if(s.form) s.form.submit(); });
    });
  })();

  const revealEls = document.querySelectorAll('.dko-reveal');
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('dko-in'); io.unobserve(e.target); } });
  }, {threshold:0, rootMargin:'0px 0px -10% 0px'});
  revealEls.forEach(el=>io.observe(el));
  // fallback: ensure nothing stays permanently invisible
  window.addEventListener('load', ()=>{
    setTimeout(()=>revealEls.forEach(el=>el.classList.add('dko-in')), 2500);
  });

  // v1.40: 顶部公告条轮播
  // 主题自带的 announcement slider（#AnnouncementSlider + Flickity）原本由 Impulse 的 header section JS 启动；
  // 我们停用了主题 header、换成 dko-header，那段初始化就不再运行，导致后台配的 3 条公告只显示第 1 条。
  // 这里补调一次主题自己的初始化，复用它的轮播（暂停按钮/无障碍行为照常），不自造一套。
  (function(){
    var bar = document.getElementById('AnnouncementSlider'); if(!bar) return;
    if(parseInt(bar.dataset.blockCount, 10) < 2) return;   // 只有一条公告时不需要轮播
    var tries = 0;
    function boot(){
      if(bar.classList.contains('flickity-enabled')) return;  // 已初始化则不重复（防主题 header 日后被启用）
      if(window.theme && theme.announcementBar && typeof theme.announcementBar.init === 'function'){
        try { theme.announcementBar.init(); } catch(e){}
        return;
      }
      if(++tries < 20) setTimeout(boot, 150);   // 等 theme.js / Flickity 就绪，最多约 3s
    }
    boot();
  })();
